<template>
  <div class="navigator-wrapper">
    <div :class="['navigator', {hidden:!state.navigatorVisible}]">
      <div v-show="state.navigatorVisible" class="design-area-navigation" />
      <div v-show="state.navigatorVisible" ref="controlDiv" :style="controlStyle" />
      <div :class="['arrow-wrapper', {hidden:!state.navigatorVisible}]">
        <tumeng-svg-icon
          v-show="state.navigatorVisible"
          class="icon toggle-visible"
          icon-class="arrow-left-top"
          @click="handleSwitchVisible"
        />
        <tumeng-svg-icon
          v-show="!state.navigatorVisible"
          class="icon toggle-visible"
          icon-class="arrow-right-bottom"
          @click="handleSwitchVisible"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store/index.js'
import { Drag } from '../../../utils/drag.js'
import TumengSvgIcon from '../../svg-icon/src/index.vue'

export default {
  name: 'TumengNavigator',
  components: { TumengSvgIcon },
  data() {
    return {
      // 拖拽div的left和top
      dragDivLeft: 20,
      dragDivTop: 20,
      state: store.state
    }
  },
  computed: {
    dragDivWidth() {
      const pi = store.state.programInfo
      if (store.state.designAreaWidth >= pi.width * pi.scale) {
        return 192
      } else {
        return 192 * store.state.designAreaWidth / pi.width / pi.scale
      }
    },
    dragDivHeight() {
      const pi = store.state.programInfo
      if (store.state.designAreaHeight >= pi.height * pi.scale) {
        return 108
      } else {
        return 108 * store.state.designAreaHeight / pi.height / pi.scale
      }
    },
    // 这是拖拽，移动显示区域的那个div
    controlStyle() {
      return {
        position: 'absolute',
        display: 'inline-block',
        borderRadius: '4px',
        cursor: 'move',
        backgroundColor: '#666',
        width: this.dragDivWidth + 'px',
        height: this.dragDivHeight + 'px',
        left: this.dragDivLeft + 'px',
        top: this.dragDivTop + 'px'
      }
    }
  },
  created() {
    this.$nextTick(() => {
      const intervalID = setInterval(() => {
        if (this.$refs.controlDiv) {
          clearInterval(intervalID)

          const _this = this
          new Drag(this.$refs.controlDiv, function(left, top) {
            // 不能超出左边界
            if (left < 0) {
              left = 0
            }
            // 不能超出上边界
            if (top < 0) {
              top = 0
            }
            // 不能超过右边界
            if (left + _this.dragDivWidth > 232) {
              left = 232 - _this.dragDivWidth
            }
            // 不能超过下边界
            if (top + _this.dragDivHeight > 148) {
              top = 148 - _this.dragDivHeight
            }

            // 拖动的同时，如何同步改变外边画布的left、top
            let canvasLeft
            let canvasTop
            if (store.state.programInfo.scale <= 1.0) {
              canvasLeft = -1 * (store.state.programInfo.width / 2) * (1 - store.state.programInfo.scale) -
                (left - 20) * store.state.programInfo.width * store.state.programInfo.scale / 192
              canvasTop = -1 * (store.state.programInfo.height / 2) * (1 - store.state.programInfo.scale) -
                (top - 20) * store.state.programInfo.height * store.state.programInfo.scale / 108
            } else {
              canvasLeft = (store.state.programInfo.width / 2) * (store.state.programInfo.scale - 1) -
                (left - 20) * store.state.programInfo.width * store.state.programInfo.scale / 192
              canvasTop = (store.state.programInfo.height / 2) * (store.state.programInfo.scale - 1) -
                (top - 20) * store.state.programInfo.height * store.state.programInfo.scale / 108
            }
            store.setCanvasPosition({ canvasLeft, canvasTop })

            _this.dragDivLeft = left
            _this.dragDivTop = top
          })
        }
      }, 50)
    })
  },
  methods: {
    handleSwitchVisible() {
      store.updateNavigatorVisible(!store.state.navigatorVisible)
    }
  }
}
</script>

<style lang="scss" scoped>
.navigator-wrapper {
  position: absolute;
  right: 16px;
  bottom: 16px;
  .navigator {
    display: inline-block;
    position: relative;
    width: 192px;
    height: 108px;
    padding: 20px;
    border-radius: 4px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    &.hidden {
      box-shadow: 0 0 0 rgba(0, 0, 0, 0), 0 0 0 rgba(0, 0, 0, 0);
      width: 0;
      height: 0;
      background-color: transparent;
    }
    .design-area-navigation {
      display: inline-block;
      width: 192px;
      height: 108px;
      border-radius: 4px;
      background-color: #cccccc;
    }
    .arrow-wrapper {
      right: 4px;
      bottom: 4px;
      position: absolute;
      width: 16px;
      height: 16px;
      padding: 4px;
      border-radius: 50%;
      background-color: #FFFFFF;
      &.hidden {
        background-color: #cccccc;
      }
      .toggle-visible {
        transition: .3s color;
        cursor: pointer;
        vertical-align: initial;
        &:hover {
          color: orange;
        }
      }
    }
  }
}
</style>
